<template>
  <v-container>
    <v-container ref="content" fluid pa-0 class="horiz-scroll">
      <v-layout row class="pfo-ml-1 pfo-pi">
        <template v-for="(similar, index) in similars" >
          <v-flex :key="similar.title" class="pfo-mr-1 pfo-mt-0 pfo-mb-1">
            <v-layout column child-flex align-center text-center elevation-3 mx-0 mb-1 class="favoritelinelayout wrap2 rounded-card" @click="loadPerfumeDetails(similar, perfFav, true, loadurl, loadingredients)">
              <v-flex style="width: 100%" mt-2 xs5 text-xs-right>
                  <v-progress-circular :color="redColor" size="24" width= "2" :value="similar.rank*100" class="match2">{{index+1}}</v-progress-circular>
                <v-img
                        :src="similar.thumb_image_url"
                        contain
                        height="90px"
                        style="width: 50%; margin-left: auto; margin-right: auto;"
                ></v-img>
              </v-flex>
              <v-flex d-flex xs3>
                <v-layout column fill-height align-center>
                  <v-progress-circular :color="redColor" size="24" width= "2" :value="similar.rank*100" class="match2">{{index+1}}</v-progress-circular>
                  <v-flex xs5 class="text-truncate font-weight-normal pfo-caption text-center customLineHeight">{{similar.name}}</v-flex>
                  <v-flex xs5 class="text-truncate font-weight-light pfo-caption text-center customLineHeight">{{similar.brand.name}}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
    <div v-if="similars && similars.length > 0" @click="scrollLeft()" style="height: 32px; width: 32px; position: absolute; left: 10px; bottom: 70px; opacity: 0.5;">
      <img :src="getArrow()" />
    </div>
    <div v-if="similars && similars.length > 0" @click="scrollRight()" style="height: 32px; width: 32px; position: absolute; right: 10px; bottom: 70px; opacity: 0.5;">
      <img style="transform: rotate(180deg);" :src="getArrow()" />
    </div>
  </v-container>
</template>
<script>
  import toolsMixin from "../mixin/toolsMixin"

  export default {
    name: 'MatchesListMobile',
    mixins: [toolsMixin],

    data () {
      return {
        pfokey: "tbd",
        customerkey: "tbd",
        similars:[],
        twocolors: 'rgba(30,30,30,1)',
        currentUrl: null,
        loadingredients: process.env.VUE_APP_LOAD_INGREDIENTS,
        loadurl: "true"
      }
    },
    props: {
      perfFav: {},
      isRTL: {
        type: Boolean,
        default: () => false
      },
            locale: {
        type: String,
        default: () => 'en'
      },
      country: {
        type: String,
        default: () => 'UK'
      },
      displayFavouriteBadge: {
        type: Boolean,
        default: () => true
      },
      scrolling: {
        type: Number,
        default:() => 0
      }
    },
    computed: {
      ourselection() {
        if (this.locale==="en") return process.env.VUE_APP_SHOP_SUGGESTION_EN
        if (this.locale==="fr") return process.env.VUE_APP_SHOP_SUGGESTION_FR
        if (this.locale==="es") return process.env.VUE_APP_SHOP_SUGGESTION_ES
        if (this.locale==="de") return process.env.VUE_APP_SHOP_SUGGESTION_DE
        if (this.locale==="ja") return process.env.VUE_APP_SHOP_SUGGESTION_JP
        if (this.locale==="ar") return process.env.VUE_APP_SHOP_SUGGESTION_AR
        if (this.locale==="pt") return process.env.VUE_APP_SHOP_SUGGESTION_PT
        if (this.locale==="sv") return process.env.VUE_APP_SHOP_SUGGESTION_SV
        if (this.locale==="ru") return process.env.VUE_APP_SHOP_SUGGESTION_RU
        if (this.locale==="tr") return process.env.VUE_APP_SHOP_SUGGESTION_TR
        if (this.locale==="ms") return process.env.VUE_APP_SHOP_SUGGESTION_MS
        if (this.locale==="it") return process.env.VUE_APP_SHOP_SUGGESTION_IT
        if (this.locale==="ko") return process.env.VUE_APP_SHOP_SUGGESTION_KO
        if (this.locale==="nl") return process.env.VUE_APP_SHOP_SUGGESTION_NL
        if (this.locale==="th") return process.env.VUE_APP_SHOP_SUGGESTION_TH
        if (this.locale==="zh") return process.env.VUE_APP_SHOP_SUGGESTION_ZH
        return process.env.VUE_APP_SHOP_SUGGESTION_EN
      },
      yourperf() {
        if (this.locale==="en") return process.env.VUE_APP_YOUR_PERFUME_EN
        if (this.locale==="fr") return process.env.VUE_APP_YOUR_PERFUME_FR
        if (this.locale==="es") return process.env.VUE_APP_YOUR_PERFUME_ES
        if (this.locale==="de") return process.env.VUE_APP_YOUR_PERFUME_DE
        if (this.locale==="ja") return process.env.VUE_APP_YOUR_PERFUME_JP
        if (this.locale==="ar") return process.env.VUE_APP_YOUR_PERFUME_AR
        if (this.locale==="sv") return process.env.VUE_APP_YOUR_PERFUME_SV
        if (this.locale==="ru") return process.env.VUE_APP_YOUR_PERFUME_RU
        if (this.locale==="tr") return process.env.VUE_APP_YOUR_PERFUME_TR
        if (this.locale==="ms") return process.env.VUE_APP_YOUR_PERFUME_MS
        if (this.locale==="it") return process.env.VUE_APP_YOUR_PERFUME_IT
        if (this.locale==="ko") return process.env.VUE_APP_YOUR_PERFUME_KO
        if (this.locale==="nl") return process.env.VUE_APP_YOUR_PERFUME_NL
        if (this.locale==="th") return process.env.VUE_APP_YOUR_PERFUME_TH
        if (this.locale==="zh") return process.env.VUE_APP_YOUR_PERFUME_ZH
        return process.env.VUE_APP_YOUR_PERFUME_EN
      },
      redColor () {
        return process.env.VUE_APP_COLOR
      }
    },
    watch: {
      // perfFav(perf) {
      //   this.callSimilars(perf)
      // }
    },
    created () {
      if (process.env.VUE_APP_PFOKEY) {
        this.pfokey = process.env.VUE_APP_PFOKEY
      }
      if (process.env.VUE_APP_CUSTOMERKEY) {
        this.customerkey = process.env.VUE_APP_CUSTOMERKEY
      }
      if (process.env.VUE_APP_LOAD_URL) {
        this.loadurl = process.env.VUE_APP_LOAD_URL
        if (this.loadurl.includes("true")) {
          this.loadurl = 'true'
        }
      }

      this.callSimilars(this.perfFav)
    },
    methods: {
      loadPerfumeDetails: function (currentperf, favperf, displayBadge, loadUrl, loadIngredients) {
        document.getElementById("carddetails").scrollTo({top: 0, behavior: 'smooth'})
        if (loadIngredients === "true") {
          this.$emit('set-perfume-details', currentperf, favperf, displayBadge)
        }
        if (loadUrl==="true") {
          localStorage.setItem('pfo_match', JSON.stringify(currentperf))
          localStorage.setItem('pfo_display_clicked_match', JSON.stringify(true))
          localStorage.setItem('pfo_close_after_match', JSON.stringify(true))
          localStorage.setItem('isOpen', JSON.stringify(false))

          this.currentUrl = window.location.hostname //pathname
          if (this.currentUrl !== 'localhost' && this.currentUrl !== 'front-app.perfumist.net') {
            console.log("HEREKLDSKJDSKJDSKJ")
            let matchurl = currentperf.url
            if (matchurl !== null) {
              if (typeof process.env.VUE_APP_UNIVERSAL_URL !== 'undefined') {
                if (process.env.VUE_APP_UNIVERSAL_URL === "true") {
                  let langurl = JSON.parse(localStorage.getItem('langPFO'))
                  matchurl = process.env.VUE_APP_CUSTOMER_URL + '/' + langurl + currentperf.url
                  if ((langurl === process.env.VUE_APP_DEFAULT_LANG) && (process.env.VUE_APP_DEFAULT_LANG_URL_ISNULL==="true")) {
                    matchurl = process.env.VUE_APP_CUSTOMER_URL + currentperf.url
                  }
                }
              }
              if (matchurl && matchurl.length > 0)
                window.open(matchurl, "_blank")
            } else { console.log('PFO match url is null') }
          }
        }
        if (loadUrl==="true") {
          if (typeof window._paq !== 'undefined') {window._paq.push(['trackEvent', 'PFO Widget','Match', currentperf.name+' - '+currentperf.brand.name+' - id:'+currentperf.id])}
        }
      },
      loadPerfumeDetails2: function (perfFav) {

        perfFav.name.toString()

        this.twocolors= 'rgba(255,255,255,1)'

        fetch(process.env.VUE_APP_API_BACKEND + '/api/products/'+perfFav.id, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: "Business "+this.pfokey,
            Accept: "version=2"
          }
        })
          .then(
            res => res.json()
          )
          .then(res => {
            this.Message = "Fetching..."
            this.similars = res.response.similar_products
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.isLoading = false
            //this.isDisabled = false
          })
      },
      callSimilars: function (perf) {

        this.perfFav.name.toString()
        this.twocolors = 'rgba(255,255,255,1)'
        var requestLocale = "" + this.locale
        if (this.locale == 'zh') {
          requestLocale = 'zh-Hans'
        }


        fetch(process.env.VUE_APP_API_BACKEND + '/api/products/' + perf.id+'?locale='+requestLocale+'&country_code='+this.country, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: "Business "+ this.customerkey,
            Accept: "version=2"
          }
        })
          .then(
            res => res.json()
          )
          .then(res => {
            this.Message = "Fetching..."
            this.similars = res.response.similar_products
            this.similars.splice(process.env.VUE_APP_MATCHES_COUNT)
            this.$emit('hide-sugg', this.similars.length == 0)
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      scrollLeft: function() {
        if (this.scrolling > 0)
          this.scrolling -= 200
        const content = this.$refs.content
        content.scrollTo({left: this.scrolling,behavior: 'smooth'})
      },
      scrollRight: function() {
        const content = this.$refs.content

        if (this.scrolling + 150 < content.scrollWidth)
          this.scrolling += 200
        content.scrollTo({left: this.scrolling,behavior: 'smooth'})
      // this.scrollTo(content, 300, 800)
      },
      getArrow() {
        return require(`@/assets/arrow.png`)
      },
      scrollTo(element, scrollPixels, duration) {
        const scrollPos = element.scrollLeft
        // Condition to check if scrolling is required
        if ( !( (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) 
        {
          // Get the start timestamp
          const startTime =
            "now" in window.performance
              ? performance.now()
              : new Date().getTime()
          
          /* eslint-disable */
          function scroll(timestamp) {
            //Calculate the timeelapsed
            const timeElapsed = timestamp - startTime
            //Calculate progress 
            const progress = Math.min(timeElapsed / duration, 1)
            //Set the scrolleft
            element.scrollLeft = scrollPos + scrollPixels * progress
            //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
            if (timeElapsed < duration) {
              //Request for animation
              window.requestAnimationFrame(scroll)
            } else {
              return
            }
          }
          //Call requestAnimationFrame on scroll function first time
          window.requestAnimationFrame(scroll)
        }
      },
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      percent: function (value) {
        if (!value) return ''
        value = value*100
        value = value.toString()
        if (value===100) value = value.substring(0,3)+"%"
        else value = value.substring(0,2)+"%"
        return value
      },
      value100: function (value) {
        if (!value) return 0
        value = value*100
        value = value.toString()
        return value
      }
    }

  }
</script>
<style scoped>

  .favoritelinelayout {
    cursor: pointer;
    position: relative;
    top: 0;
    bottom: 3px;
    right: 0;
    left: 0;
    width: 160px;
    height: 150px;
    color: rgba(30,30,30,1);
    background-color: white;
    border-bottom-color: #43454b;
    border-bottom-width: thin;
  }

  .match2 {
    color: #BF1E2E;
    font-weight: normal;
    font-size: 14px;
    align-content: center;
    position: absolute;
    top: 10px;
    left: 10px;

  }

  .justify-center{
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .textoverflow {
    width: 85%;
    overflow: hidden !important;
    text-overflow: ellipsis  !important;
    white-space: nowrap;
    display: inline-block;
  }
  .vperfmarginunset {
    margin: unset;
  }
  .fav-img {
    height: 50px;
  }
  .match-img {
    height: 72px;
  }
  .wrap2 {
    flex-wrap: wrap;
  }
  .fxsp {
    font-size: 10px;
  }
  .rounded-card{
    border-radius:5px;
  }
  .pfo-mr-1 {
    margin-right: 10px;
    margin-left: 10px;
  }
  .pfo-mr-3 {
    margin-right: 16px;
  }
  .pfo-ml-1 {
    margin-left: 4px;
    flex-wrap: nowrap;
  }
  .pfo-mt-0 {
    margin-top: 10px;
  }
  .pfo-mb-1 {
    margin-bottom: 4px;
  }
  .pfo-pi {
    padding: initial;
  }
  .customLineHeight {
    line-height: 1.40rem !important;
  }

  div > .pfo-caption {
    font-size: 12px !important;
  }
</style>
